import React from 'react';

import {
  Container,
  Button,
  Image,
} from '@uncinc/uncinc-react-kitchen-sink';

import { WysiwygField } from '../../../components';

import './style.scss';

const ParagraphImageAndText = ({ entity }) => {
  const title = entity.getIn(['field_title', 0, 'value'], '');
  const body = entity.getIn(['field_body', 0, 'processed'], '');
  const image = entity.getIn(['field_media_item', 0, 'styles', 'teaser_large'], '');
  const alt = entity.getIn(['field_media_item', 0, 'alt'], '');
  const linkHref = entity.getIn(['field_link', 0, 'alias'], entity.getIn(['field_link', 0, 'uri']));
  const linkTitle = entity.getIn(['field_link', 0, 'title']);

  return (
    <Container className="ParagraphImageAndText" small>
      <div className="row">
        <div className="col-12 col-md-4">
          <Image
            alt={alt}
            lazyload={false}
            className="ParagraphImageAndText__image"
            src={image}
          />
        </div>
        <div className="col-12 col-md-8">
          {title ? (
            <div className="ParagraphImageAndText__title">{title}</div>
          ) : null}
          {body ? (
            <WysiwygField
              property="schema:text"
              className="ParagraphImageAndText__body"
              html={body}
            />
          ) : null}
          {linkHref && linkTitle && (
            <Button className="ParagraphImageAndText__button" inverted href={linkHref}>{linkTitle}</Button>
          )}
        </div>
      </div>
    </Container>
  );
};

export default ParagraphImageAndText;
